import { useEffect, useState } from 'react';

/** The value after it has stopped changing for `delayMs`. A delay of 0 passes it through at once. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    if (delayMs <= 0) {
      setDebounced(value);
      return undefined;
    }
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);
  return delayMs <= 0 ? value : debounced;
}
